import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { first, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '@bn/auth/services';
import { AppRoutes, ErrorsRoutes } from '@bn/dashboard-core/enums';

@Injectable({ providedIn: 'root' })
export class AccountSuspendedGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.authService.getAuthStore().pipe(
      switchMap((authStorage) => {
        if (authStorage?.user?.Suspended) {
          this.router.navigate(['/', AppRoutes.Errors, ErrorsRoutes.AccountSuspended]);

          return of(false);
        }

        return of(true);
      }),
      first(),
    );
  }
}
